module.exports = __webpack_public_path__ + "img/eye-black.25044a28.svg";